export enum PermutiveEvent {
    FIRE_PAGE_VIEW = 'permutiveFirePageView'
}
